import { Component, ViewEncapsulation, OnInit, Renderer2, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { TranslateService } from '@ngx-translate/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Title } from '@angular/platform-browser';
import { LandingService } from './landing.service';
import { HttpService } from '../../services/http.service';
import { AccessibilityService } from '../../services/accessibility.service';
import { ErrorService } from '../error/error.service';
import { TravelersService } from '../travelers/travelers.service';
import { SwitchService } from '../switch/switch.service';
import { AppService } from '../../app.service';
import { DatalayerService } from '../../services/datalayer.service';
import { BuywifiService } from '../../services/buywifi.service';
import { ActivateService } from '../../services/activate.service';

import { LandingAccessibilityModel } from './landing.model';
import { WifiActivateRequestModel } from '../travelers/travelers.model';
import { ONBOARD_CONSTANTS } from '../../app.constants';
import * as MiscLib from '@flysas/misc-lib';
import { PaymentSelectionComponent } from '../eb/paymentSelection.component';
import { VoucherComponent } from '../voucher/voucher.component';
import { AuthService } from '@auth0/auth0-angular';
import jwt_decode from "jwt-decode";
import { TravelersComponent } from '../travelers/travelers.component';
declare let $: any;

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./landing.component.css']
})
export class LandingComponent implements OnInit {
  static showActivateScreen = false;
  static showSwitchScreen = false;
  static showLandingBanner = true;
  static disableConnectButton = false;
  static isDeviceActivated = false;
  static showToggleButton = true;
  static isbuyButtonTrigger = false;
  static showPaymentSelectionScreen = false;
  static showVoucherLogin = false;
  static voucherConnect = false;
  showVoucherLink = false;
  showVoucherCharter = false;
  showLongHaulText = false;
  readmoreOverLay = false;
  showLandingTerms = false;
  hideLandingBanner = true;
  sasTnCChecked = false;
  enableLandingTermsBtn = false;
  showSasTnC = false;
  landingCompo = false;
  showSastandcondErrorMsg = false;
  public isDeviceStatusFull = false;
  accessiTranslate: LandingAccessibilityModel = { 'enterToContinue': '' };
  private deviceStatusCheckAfterLoginSubscription: Subscription;
  private deviceStatusCheckAfterDisconnectWifiSubscription: Subscription;
  public sasTnC: any;
  private feedback: { showFeedback: () => void; };
  private deviceTokenCount: any;
  private deviceTokenCountVal: any;
  public deviceInfo: any;
  public pos: any;
  public lang: any;
  public showPrices: any;
  public formatPrices: any;
  public isCharter: boolean;
  public showFlightNumber: any;
  public enableFeature: boolean;
  isGrabitEnable = false;
  grabitUrl: any;
  configuredTailId: any;
  configuredFlightId: any;
  buyMoreDevice = true;
  public showEBforPointsBuy = PaymentSelectionComponent.showEBforPointsBuy;
  public buyMoreFlowForEB = PaymentSelectionComponent.buyMoreFlowForEB;
  accessToken: any;
  public isAuthenticated: boolean = false;

  @HostListener('window:keydown', ['$event'])
  keyboardInput(event: KeyboardEvent) {
    if (event.key === 'Escape' && this.showSwitchScreen) {
      event.preventDefault();
      this.accessibilityService.focus('#close-switch');
    }
  }

  constructor(
    private landingService: LandingService,
    private httpService: HttpService,
    private errorService: ErrorService,
    private travelersService: TravelersService,
    private switchService: SwitchService,
    private appService: AppService,
    private accessibilityService: AccessibilityService,
    private router: Router,
    private titleService: Title,
    private deviceService: DeviceDetectorService,
    private datalayerService: DatalayerService,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute,
    private buywifiService: BuywifiService,
    private activateService: ActivateService,
    private renderer: Renderer2,
    private auth: AuthService) {
    //console.log('landing comp')
    //console.log('USER LOGGED IN ?',sessionStorage.getItem('isAuthenticated'));
    this.devicStatusCheckAfterLoginSubscribe();
    this.devicStatusCheckAfterDisconnectWifiSubscribe();
  }

  async ngOnInit() {
    this.pos = this.appService.getPOS();
    this.lang = this.appService.getLanguage();
    this.hideLandingBanner = true;
    this.enableFeature = false
    const onboardEnable = this.landingService.checkOnboardEnable();
    if (onboardEnable) {
      await this.getDevice();
      this.configuredTailId = this.translate.instant('grabit.tailid');
      this.configuredFlightId = this.translate.instant('grabit.flightnumber');
      this.landingService.showViews();
    } else {
      const baseUrl = `https://${window.location.hostname}/`;
      window.location.href = baseUrl;
    }
    this.translate.get('sasOnboard').subscribe((result: string) => {
      this.titleService.setTitle(result);
    });
    this.loadAccessibilityTranslations();
    this.showFeedback();
    this.landingService.setDeviceName(this.deviceService);
    this.accessibilityService.setSkipLinkId('landing-connect');
    this.buywifiService.checkReleaseCall();
    this.appService.showLoader();
  }

  loadScript(src: string): Promise<void> {
    return $.getScript(src)
      .done(function (script, textStatus) {

      })
      .fail(function (jqxhr, settings, exception) {
        $("div.log").text("Triggered ajaxError handler.");
      });
  }
  closeLoader(type: string, status: string) {
    if (type === 'charter') {
      this.isCharter = true;
    }
    const thisVal = this.appService;
    // this.landingService.loadHomeBanner(topBannerSession);
    if (status === 'FULL') {
      this.landingService.hideLandingBannerText();
    }
    setTimeout(function () { thisVal.hideLoader(); }, 100);
  }

  showFeedback() {
    if (!this.feedback) {
      this.translate.get(['feedbackOnboard.flag', 'feedbackOnboard.url']).subscribe(result => {
        if (result['feedbackOnboard.flag']) {
          this.feedback = new MiscLib.Misc('#Feedback', {
            link: result['feedbackOnboard.url'],
            btnVal: 'Feedback'
          });
          this.feedback.showFeedback();
        }
      });
    }
  }

  /* redirectToBuywifi() {
    this.appService.showLoader();
    this.landingService.setChatBotHide();
    LandingComponent.showActivateScreen = true;
    LandingComponent.showToggleButton = false;
    this.errorService.removeError();
  } */

  openPaymentSelectionPage() {
    this.landingService.setChatBotHide();
    PaymentSelectionComponent.buyMoreFlowForEB = true;
    LandingComponent.showPaymentSelectionScreen = true;
    this.errorService.removeError();
  }

  openVoucherConnectPage() {
    this.landingService.setChatBotHide();
    LandingComponent.showVoucherLogin = true;
    this.errorService.removeError();
  }
  private devicStatusCheckAfterLoginSubscribe() {
    this.deviceStatusCheckAfterLoginSubscription = this.appService.deviceStatusCheckAfterLoginOrLogoutObservable.subscribe(
      doDeviceStatusCheck => {
        if (doDeviceStatusCheck) {
          this.deviceStatusCheck();
        }
      });
  }

  private devicStatusCheckAfterDisconnectWifiSubscribe() {
    this.deviceStatusCheckAfterDisconnectWifiSubscription = this.appService.deviceStatusCheckAfterDisconnectWifiObservable.subscribe(
      doDeviceStatusCheck => {
        if (doDeviceStatusCheck) {
          this.getDevice();
        }
      });
  }

  getTnCData() {
    const baseUrl = this.appService.getTncBaseUrl();
    this.translate.get(['sasTnC.text']).subscribe(result => {
      const tncUrls = baseUrl + result['sasTnC.text'];
      this.httpService.getHtml(tncUrls).subscribe(tncData => {
        this.sasTnC = tncData;
      });
    });
  }

  getDevice() {
    //console.log('getDevice Call');
    const deviceToken = this.appService.getDeviceToken();
    if (deviceToken && deviceToken !== 'null' && deviceToken !== '') {
      this.appService.showLoader();
      const getDevicRequestEntity = this.landingService.getDeviceRequestEntity(deviceToken);
      this.httpService.getData(getDevicRequestEntity).subscribe(
        getDeviceResponse => {

          if (getDeviceResponse.errors) {
            LandingComponent.disableConnectButton = true;
            this.errorService.addError(getDeviceResponse.errors);
            this.appService.hideLoader();
          } else {
            const fightResponseData = this.appService.getFlightResponse();
            const flightId = (getDeviceResponse.flightId).split('-');
            // LandingComponent.voucherConnect = (getDeviceResponse && getDeviceResponse.passenger && !getDeviceResponse.passenger.firstname
            //   && !getDeviceResponse.passenger.lastName) ? true : false;
            LandingComponent.voucherConnect = getDeviceResponse && getDeviceResponse?.passenger ? getDeviceResponse?.passenger.voucherCode ? true : false : true;
            this.showVoucherLink = (fightResponseData && fightResponseData.longRange && fightResponseData.flightType === ONBOARD_CONSTANTS.COMMERCIAL) ? fightResponseData.longRange : false;
            this.showVoucherCharter = (fightResponseData && fightResponseData.longRange && fightResponseData.flightType === ONBOARD_CONSTANTS.CHARTER && (fightResponseData.origin.iataCode === ONBOARD_CONSTANTS.CHATER_VOUCHER_ORG_DST || fightResponseData.destination.iataCode === ONBOARD_CONSTANTS.CHATER_VOUCHER_ORG_DST)) ? fightResponseData.longRange : false;
            this.showLongHaulText = (fightResponseData && fightResponseData.longRange) ? fightResponseData.longRange : false;
            if (fightResponseData && flightId[0] && fightResponseData.flightNumber === flightId[0]) {
              this.updateFlightResponse(fightResponseData, getDeviceResponse)
              this.showPrices = JSON.parse(fightResponseData && fightResponseData.prices) || "";
              this.formatPrices = Object.entries(this.showPrices);
              const hostname = window.location.hostname;
              if (hostname === "localhost" || hostname.includes("test")) {
                this.showFlightNumber = fightResponseData && fightResponseData.flightNumber;
              } else {
                this.showFlightNumber = null;
              }
            } else {
              const chatRequestUrl = this.landingService.getChatRequestUrl(getDeviceResponse);
              this.httpService.getData(chatRequestUrl).subscribe(
                flightResponse => {
                  sessionStorage.setItem('flightData', JSON.stringify(flightResponse));
                  const flightDataResopnse = JSON.parse(sessionStorage.getItem('flightData'));

                  if (flightDataResopnse !== null && flightDataResopnse !== '') {
                    sessionStorage.setItem('priceList', JSON.stringify(flightResponse && flightResponse.prices));
                    this.showPrices = JSON.parse(flightResponse && flightResponse.prices) || "";
                    this.formatPrices = Object.entries(this.showPrices);
                    const hostname = window.location.hostname;
                    if (hostname === "localhost" || hostname.includes("test")) {
                      this.showFlightNumber = flightResponse && flightResponse.flightNumber;
                    } else {
                      this.showFlightNumber = null;
                    }

                  }
                  this.showVoucherLink = (flightResponse && flightResponse.longRange && flightResponse.flightType === ONBOARD_CONSTANTS.COMMERCIAL) ? flightResponse.longRange : false;
                  this.showVoucherCharter = (flightResponse && flightResponse.longRange && flightResponse.flightType === ONBOARD_CONSTANTS.CHARTER && flightResponse.origin.iataCode === ONBOARD_CONSTANTS.CHATER_VOUCHER_ORG_DST || flightResponse.destination.iataCode === ONBOARD_CONSTANTS.CHATER_VOUCHER_ORG_DST) ? flightResponse.longRange : false;
                  this.showLongHaulText = (flightResponse && flightResponse.longRange) ? flightResponse.longRange : false;
                  this.updateFlightResponse(flightResponse, getDeviceResponse);
                },
                error => {
                  this.errorService.addError(this.landingService.getDefaultError());
                  this.appService.hideLoader();
                }
              );
            }
            if (JSON.parse(sessionStorage.getItem('isAuthenticated'))) {
              this.connectToWifi();
              //console.log('New EB Activate Call');
            }
          }

          this.appService.hideLoaderWithText();
        },
        error => {
          LandingComponent.disableConnectButton = true;
          this.errorService.addError(this.landingService.getDefaultError());
          this.appService.hideLoader();
          this.appService.hideLoaderWithText();
        });
    } else {
      LandingComponent.disableConnectButton = true;
      if (deviceToken === 'null' || deviceToken === '' || deviceToken === null) {
        this.deviceTokenCount = sessionStorage.getItem('dTNullCount');
        if (this.deviceTokenCount && Number(this.deviceTokenCount) > ONBOARD_CONSTANTS.NULLCHECKCOUNT) {
          this.errorService.addError(this.landingService.getDeviceTokenNullError());
        } else {
          this.deviceTokenCountVal = Number(this.deviceTokenCount) + 1;
          sessionStorage.setItem('dTNullCount', this.deviceTokenCountVal);
          window.location.href = ONBOARD_CONSTANTS.REDIRECTION_URL;
        }
      } else {
        this.errorService.addError(this.landingService.getDeviceTokenNullError());
      }
      this.appService.hideLoader();
    }

  }

  updateFlightResponse(flightResponse, getDeviceResponse: { errors: any; status: { code: string; }; passenger: any; }) {
    if (flightResponse.errors) {
      LandingComponent.disableConnectButton = true;
      this.errorService.addError(getDeviceResponse.errors);
      this.appService.hideLoader();
    } else {
      this.enableFeature = true;
      this.landingService.setGetDeviceResponse(getDeviceResponse);
      this.appService.setGetDeviceResponse(getDeviceResponse);
      this.appService.setFlightResponse(flightResponse);
      this.deviceStatusCheck();
      this.updateChatUrltoSession();
      this.datalayerService.getDeviceDataLayer(getDeviceResponse.status.code);
      this.closeLoader(flightResponse.flightType, getDeviceResponse.status.code);
      if (getDeviceResponse.status.code === 'FULL') {
        this.accessibilityService.setSkipLinkId('buy-wifi-home');
        const wifiDestination = sessionStorage.getItem('setWifidestination');
        if (!wifiDestination || wifiDestination === 'false') {
          if (getDeviceResponse.passenger && !this.appService.getFlightServiceType()) {
            this.landingService.setFinalDestinationDataToSession(getDeviceResponse);
          } else {
            this.updateSessionFlightData(flightResponse);
          }
        }
        this.landingService.hideLandingBannerText();
        this.isDeviceStatusFull = true;
        this.appService.setActivateStatus(true);
      } else {
        this.updateSessionFlightData(flightResponse);
        this.isDeviceStatusFull = false;
        this.appService.setActivateStatus(false);
        LandingComponent.isDeviceActivated = false;
        LandingComponent.showLandingBanner = true;
        this.isGrabitEnable = this.appService.identifyGrabitStatus(this.configuredFlightId, this.configuredTailId);
        this.grabitUrl = ONBOARD_CONSTANTS.GRABIT_URL + this.appService.getDeviceToken();
      }
      this.landingService.getNetFlixBanner(getDeviceResponse.status.code);
      this.activateConnectPage();
    }
  }

  updateSessionFlightData(flightResponse: { origin: { iataCode: string; }; destination: { iataCode: string; }; }) {
    sessionStorage.setItem('wifiorigin', flightResponse.origin.iataCode);
    sessionStorage.setItem('wifidestination', flightResponse.destination.iataCode);
  }

  deviceStatusCheck() {
    const deviceStatus = this.landingService.checkDeviceStatus();
    if (deviceStatus.wifiActivated) {
      this.landingService.hideLandingBannerText();
      LandingComponent.isDeviceActivated = true;
      LandingComponent.showLandingBanner = false;
      this.errorService.addConnectedNotification();
      this.appService.changeDisconnectWifiStatus();
    } else if (deviceStatus.error) {
      LandingComponent.disableConnectButton = true;
      this.errorService.addError(this.landingService.getErrors());
    }
  }

  connectToWifi() {
    const loaderTextList = { loaderHeaderText: 'getStarted' };
    this.appService.showLoaderWithText(loaderTextList);
    this.travelersService.deleteLoggedInInfo();
    const deviceStatus = this.landingService.getGetDeviceStatus();
    //console.log('Device Status: ', deviceStatus);
    LandingComponent.showToggleButton = true;
    if (deviceStatus.doActivateCall) {
      if (deviceStatus.paxObjectFound) {
        const activateRequest = this.landingService.getActivateRequest();
        this.doActivateCall(activateRequest);
      } else if (deviceStatus.paxLoggedIn) {
        this.appService.hideLoaderWithText();
        this.getTnCData();
        //this.showTermsAndCons();
        this.newEBLogin();
      }
    } else if (deviceStatus.gotoActivateScreen) {
      LandingComponent.showActivateScreen = true;
      this.errorService.removeError();
      this.appService.hideLoaderWithText();
    } else if (deviceStatus.error) {
      LandingComponent.disableConnectButton = true;
      this.errorService.addError(this.landingService.getErrors());
      this.appService.hideLoaderWithText();
    } else if (deviceStatus.wifiActivated) {
      this.appService.hideLoaderWithText();
    } else {
      LandingComponent.disableConnectButton = true;
      this.errorService.addError(this.landingService.getDefaultError());
      this.appService.hideLoaderWithText();
    }
    this.landingService.setProfileData();
  }

  getChatUrl() {
    const deviceData: any = this.landingService.getGetDeviceResponse();
    const flightData: any = this.appService.getFlightResponse();
    let callsignVal = '';
    if (flightData && flightData.callSigns) {
      callsignVal = flightData.callSigns.trim('');
    }
    const chatUrl = this.landingService.getChatUrl().replace('<<vehicleId>>', flightData.vehicleId)
      .replace('<<callSigns>>', callsignVal)
      .replace('<<origin>>', flightData.origin.icaoCode)
      .replace('<<destination>>', flightData.destination.icaoCode)
      .replace('<<token>>', deviceData.token)
      .replace('<<appLanguage>>', this.appService.getLanguage());
    return chatUrl;
  }

  connectToChat() {
    const chatUrl = this.getChatUrl();
    this.appService.hideLoader();
    this.datalayerService.addChatEventToDatalayer();
    window.open(chatUrl, '_blank');
  }

  updateChatUrltoSession() {
    const chatUrl = this.getChatUrl();
    sessionStorage.setItem('chatUrl', chatUrl);
  }

  showTermsAndCons() {
    this.appService.removeScrollBody();
    this.sasTnCChecked = false;
    this.enableLandingTermsBtn = false;
    this.showLandingTerms = true;
    this.accessibilityService.focus('#sasTnCEb');
    this.appService.hideLoader();
  }

  keytabFocus(event: { preventDefault: () => void; }, id: any) {
    this.accessibilityService.focus(id);
    event.preventDefault();
  }

  keyshiftTabFocus(event: { shiftKey: any; key: string; preventDefault: () => void; }, id: any) {
    if (event.shiftKey && event.key === 'Tab') {
      this.accessibilityService.focus(id);
      event.preventDefault();
    }
  }

  newEBLogin() {
    this.appService.showLoader();
    this.showLandingTerms = false;
    const activateRequest = this.landingService.getActivateRequest();
    this.doActivateCall(activateRequest);
  }

  connectToWifiFromTerms() {
    if (this.enableLandingTermsBtn) {
      this.appService.showLoader();
      this.showLandingTerms = false;
      const activateRequest = this.landingService.getActivateRequest();
      this.doActivateCall(activateRequest);
    } else {
      this.showSastandcondErrorMsg = true;
    }
  }

  checkLandingTermsBtn() {
    if (this.sasTnCChecked) {
      this.enableLandingTermsBtn = true;
      this.showSastandcondErrorMsg = false;
    } else {
      this.enableLandingTermsBtn = false;
    }
  }

  closeLandingTermsOverlay() {
    this.appService.addScrollBody();
    this.showLandingTerms = false;
  }

  doActivateCall(request: WifiActivateRequestModel) {
    this.activateService.doActivateCall(request).subscribe(
      activateResponse => {
        if (activateResponse.errors) {
          // Change for OWE-508
          if (activateResponse.connectionType === 'RESTRICTED') {
            this.datalayerService.postActivateDataLayerError('RESTRICTED');
            this.appService.hideLoaderWithText();
          }
          // Change ends
          this.updateErrorResponse(activateResponse);
        } else if (activateResponse.status && activateResponse.status.code === 'FULL') {
          LandingComponent.isDeviceActivated = true;
          LandingComponent.showLandingBanner = false;
          this.datalayerService.activateDataLayer('Connection successful  - Eurobonus');
          this.appService.addScrollBody();
          this.appService.scrollToTop();
          this.errorService.removeError();
        }
      },
      error => {
        this.errorService.addError(this.landingService.getDefaultError());
        this.appService.hideLoader();
        this.appService.hideLoaderWithText();
      }
    )
  }


  updateErrorResponse(activateResponse: { errors: any; links: any; }) {
    for (const error of activateResponse.errors) {
      const errorCode = error.errorCode;
      if (errorCode === '7011016') {
        this.getDeciveTypeCall(activateResponse);
      } else if (errorCode === '7011012') {
        this.openPaymentSelectionPage();
      } else if (errorCode === '7011010' || errorCode === '7011013' || errorCode === '7011020'
        || errorCode === '7011053') {
        if (errorCode === '7011053') {
          const despError = [{
            'errorCode': '7011058',
            'errorMessage': 'We couldn\'t find your Eurobonus details or you\'re not a Diamond or Gold member.'
              + 'please use your booking reference.'
          }];
          this.errorService.addError(despError);
        } else {
          this.errorService.addError(activateResponse.errors);
        }
        const sessionId = this.appService.getSessionId();
        if (sessionId) {
          this.travelersService.setAlreadyLoginError(error.errorCode, activateResponse.errors);
        }
        LandingComponent.showActivateScreen = true;
      } else {
        this.errorService.addError(activateResponse.errors);
        this.appService.hideLoader();
      }
    }
  }

  getDeciveTypeCall(activateResponse: { links: any; }) {
    for (const link of activateResponse.links) {
      if (link.rel === 'PassengerAssociatedDevices') {
        const loaderTextList = { loaderHeaderText: 'loaderText' };
        this.appService.showLoaderWithText(loaderTextList);
        this.errorService.removeError();
        const paxId = link.href.split('=')[1];
        const getDeviceTypeRequest = this.landingService.getDeviceTypesRequest(paxId);
        this.httpService.getData(getDeviceTypeRequest).subscribe(
          deviceTypeResponse => {
            if (deviceTypeResponse.errors) {
              this.errorService.addError(deviceTypeResponse.errors);
              this.appService.hideLoader();
            } else {
              this.switchService.setConnectedCount(deviceTypeResponse);
              this.switchService.setDataFromLanding(deviceTypeResponse, this.landingService.getGetDeviceResponse(), paxId);
              LandingComponent.showSwitchScreen = true;
              LandingComponent.isDeviceActivated = false;
              this.errorService.removeError();
            }
          },
          error => {
            this.errorService.addError(this.landingService.getDefaultError());
            this.appService.hideLoader();
          }
        )
      }
    }
  }

  activateConnectPage() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params && (params.pnr || params.firstname || params.lastname || params.username)) {
        this.connectToWifi();
        this.landingService.showhashTagUrl = true;
      } else {
        this.landingService.showhashTagUrl = false;
        if (!params.deviceToken) {
          if (ONBOARD_CONSTANTS.ENABLE_DEVICE_TOKEN_STRIPPING) {
            this.router.navigate(['']);
          } else {
            this.router.navigate([''], { queryParams: { 'deviceToken': sessionStorage.getItem('deviceToken') } });
          }
        }
      }

    });
  }

  readmoreContent() {
    this.readmoreOverLay = true;
   // this.buywifiService.readmoreContent(this.pos, this.lang);
  }

  closeOverlay() {
    this.readmoreOverLay = false;
  }

  get showPaymentSelectionScreen() {
    return LandingComponent.showPaymentSelectionScreen;
  }
  get showVoucherLogin() {
    return LandingComponent.showVoucherLogin;
  }

  get showActivateScreen() {
    return LandingComponent.showActivateScreen;
  }

  get showSwitchScreen() {
    return LandingComponent.showSwitchScreen;
  }

  get showLandingBanner() {
    return LandingComponent.showLandingBanner;
  }
  get voucherConnectActivate() {
    return LandingComponent.voucherConnect;
  }

  get connectButtonDisabled() {
    return LandingComponent.disableConnectButton;
  }
  get wifiConnected() {
    return LandingComponent.isDeviceActivated;
  }

  openSasTnC() {
    this.showSasTnC = true;
    this.accessibilityService.focus('#termsAndConClose');
  }

  closeSasTnC() {
    this.showSasTnC = false;
    this.accessibilityService.focus('#sasLinkAccess');
  }

  // Accessibility Methods
  private loadAccessibilityTranslations() {
    this.translate.get(['connectWiFi', 'button', 'pressEnter', 'toContinue']).subscribe(result => {
      const connectBtn = `${result['connectWiFi']} ${result['button']}.`;
      this.accessiTranslate.enterToContinue = connectBtn + result['pressEnter'] + result['toContinue'];
    });
  }
  evntDetect(event: { preventDefault: () => void; }, id: any) {
    event.preventDefault();
    this.accessibilityService.focus(id);
  }
  tabFromViasatTAC(event: { preventDefault: () => void; }) {
    event.preventDefault();
    this.accessibilityService.focus('#onboard-connect-btn');
  }
  tabFromLandingButton(event: { preventDefault: () => void; }) {
    event.preventDefault();
    this.accessibilityService.focus('#close-switch');
  }
  termsAndConditionEvents(event: { preventDefault: () => void; }, id: any) {
    event.preventDefault();
    this.accessibilityService.focus(id);
  }
  @HostListener('window:keydown', ['$event'])
  keyboardEvents(event: { key: string; shiftKey: any; target: { id: string; }; preventDefault: () => void; }) {
    if ((event.key === 'Tab' && !event.shiftKey && (event.target.id === 'freeInternetConnectivity'))) {
      event.preventDefault();
      this.landingCompo = true;
    } else {
      this.landingCompo = false;
    }
  }
}
